import { render, staticRenderFns } from "./EventDefinitionDetails.vue?vue&type=template&id=a2768c22&scoped=true&"
import script from "./EventDefinitionDetails.vue?vue&type=script&lang=js&"
export * from "./EventDefinitionDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventDefinitionDetails.vue?vue&type=style&index=0&id=a2768c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2768c22",
  null
  
)

export default component.exports